export function debounce(callback: () => void, wait: number, immediate = false) {
  let timeout: number;
  return function() {
    const context = this;
    const args = arguments;
    const later = (): void => {
      timeout = undefined;
      if (!immediate) {
        callback.apply(context, args);
      }
    };
    const callNow = immediate && !timeout;

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) callback.apply(context, args);
  };
}
